export default {
 onUpdate: registration => {
   window.sessionStorage.clear();
   registration.unregister();
 },
}